module.exports = __webpack_public_path__ + "static/abe-68f1d75c7f83bce71d9520d744c175d8.jpg";